import React, { useState, useEffect } from "react";
import { IonPage, IonContent, IonButton, IonToolbar,IonFooter, IonSpinner, IonInput, IonText, IonModal, IonIcon, IonHeader, useIonAlert, IonGrid, IonRow, IonCol } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { parsePhoneNumber } from 'awesome-phonenumber';

import './PhonePage.css';
import { split } from "lodash-es";

import CountryPhoneSelection from '../../../components/CountrySelection/CountryPhoneSelection';
import {chevronDownOutline } from "ionicons/icons";
import AppHeader from "../../../components/AppHeader/AppHeader";
import { useAppSelector, useAppDispatch } from '../../../services/redux/hook';
import { setUser } from "../../../services/redux/slices/user/user";
import { PhoneTokenRequestParameters, UserInfo } from "../../../types/types";
import { ebioroApi } from "../../../services/api/ebioro/ebioro";

import * as Sentry from '@sentry/react';

const isTestnet = import.meta.env.VITE_isTestnet === 'true' ? true : false;

const PhonePage: React.FC<any> = () => {

    const history = useHistory();
    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation();
    const user: UserInfo = useAppSelector((state) => state.user);
    const [countryCallingCode, setcountryCallingCode] = useState("+1");
    const [inputLabel,setInputLabel] = useState(countryCallingCode)
    const [countryName, setCountryName] = useState('');
    const [isSpinner, setIsSpinner] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState<any>('');
    const [isButtonEnabled, setIsButtonEnabled] = useState<boolean>(false);
    const [countrySelectionModalPage, setCountrySelectionModalPage] = useState(false);
    const [present] = useIonAlert();
    const [auth_token, setAuthToken] = useState<string>();


    const presentErrorAlert = (error: any) => {

        present({
            header: 'Error',
            message: `${error.data}`,
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    handler: () => {
                        return
                    }
                }
            ],

        })

    }

    const sendOTP = async () => {

        setIsSpinner(true);

        const updatedUser = { ...user };

        updatedUser.mobile_number = phoneNumber;
        updatedUser.calling_code = countryCallingCode;
        dispatch(setUser(updatedUser));

        const params: PhoneTokenRequestParameters = {

            email: updatedUser.email,
            mobile: updatedUser.mobile_number,
            auth_token: auth_token as string

        }

        try {

            const response = await dispatch(ebioroApi.endpoints.getPhoneVerificationToken.initiate(params, { forceRefetch: true })).unwrap();
            setIsSpinner(false);
            history.push({
                pathname: '/signup/verify-phone', state: {
                    detail: {
                        verifyTokenId: response.message,
                        auth_token: response.auth_token
                    }
                }
            });

        } catch (error: any) {

            if (error.status == 409) {
                setIsSpinner(false);
                presentErrorAlert({ data: error.data.error })
                return

            }

            else {

                Sentry.captureException(error);
                setIsSpinner(false);
                presentErrorAlert({ data: t('application.uncaught.ERROR') });
                return
            }

        }

    }

    const checkPhoneNumber = (phoneNumber: any) => {

        // we will start evaluating only if the length of the phone number is >4
        if (phoneNumber.length <= 4) {
            return false
        }

        try {

            const completeNumber = countryCallingCode + phoneNumber;
            const pn = parsePhoneNumber(completeNumber);

            if (pn.valid) {

                let validNumber = pn.number.e164
                setPhoneNumber(validNumber)
                setIsButtonEnabled(true);
            }

            else {

                setIsButtonEnabled(false);

            }

        } catch (error) {
            return false;

        }

    }

    const showCountrySelectionPage = () => {

        setCountrySelectionModalPage(true);
    }

    const closeCountrySelectionPage = () => {
        setCountrySelectionModalPage(false)
    }

    const updateContryCode = (callingCode:string)=>{
        setcountryCallingCode(`+${callingCode}`);
        setInputLabel(`+${callingCode}`)
    }

    useEffect(() => {

        const init = async () => {

            try {

                const response = await dispatch(ebioroApi.endpoints.apiRoot.initiate({}, { forceRefetch: true })).unwrap();

                if (response.calling_code) {

                    let calling_code = response.calling_code;
                    calling_code = split(calling_code, '+')[1];

                    const location: any = history.location;
                    const auth_token = location.state.detail.auth_token as string;
                    
                    //initial user calling codes based on ip address
                    updateContryCode(calling_code);
                    setAuthToken(auth_token);

                }

            } catch (error) {

                Sentry.captureException(error);
                presentErrorAlert({ data: t('application.uncaught.ERROR') })
                return;
            }

        }

        init();

    }, [dispatch]);

    return (
        <IonPage>
            <IonHeader className="ion-no-border">

                <AppHeader
                    title={t('registration.phone.HEADER') as string}
                    goBack={true}
                >
                </AppHeader>


            </IonHeader>
            <IonContent scrollY={false}>

                <IonModal isOpen={countrySelectionModalPage}>

                    <CountryPhoneSelection 
                        closeAction={closeCountrySelectionPage} 
                        setCallingCode={updateContryCode}
                        setCountryName={setCountryName}
                        phone={true}
                    />

                </IonModal>

                <form style={{ padding: 18 }}>
                    <IonGrid>
                        <IonRow>
                            <IonCol size="3">
                                <IonButton 
                                    fill="outline" 
                                    expand="block"
                                    onClick={showCountrySelectionPage}
                                    className="ion-text-center"
                                >
                                    <span>{inputLabel}</span>
                                    <IonIcon icon={chevronDownOutline} slot="end" />
                                </IonButton>
                            </IonCol>
                            <IonCol size="9">
                                <IonInput
                                    label={`${t('registration.phone.HEADER')}`}
                                    className="ion-text-start"
                                    labelPlacement="floating"
                                    mode="md"
                                    fill="outline"
                                    placeholder={t("registration.phone.placeholder") as string}
                                    inputMode='tel'
                                    onIonInput={(e:any) => checkPhoneNumber(e.detail.value)}
                                />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </form>

                <IonText color="medium" className="ion-text-center" >
                    <p style={{marginTop:'5%'}} className="phonePageInfoText ion-text-wrap" >{t('registration.phone.info')}</p>
                </IonText>
            </IonContent>
            <IonFooter className="ion-no-border">
                <IonToolbar>
                    <IonButton
                        color='primary'
                        type="submit"
                        onClick={() => sendOTP()}
                        disabled={!isButtonEnabled}
                        expand="block"
                        id='pageFooterButton'>
                        {isSpinner ? (<IonSpinner className="BUTTON-SPINNER"></IonSpinner>)
                            : t('registration.name.BTN_CONT')}

                    </IonButton>
                </IonToolbar>
            </IonFooter>
        </IonPage>
    )
}

export default PhonePage